import SignupFromInvitationInteractor from '../../interactors/signup_from_invitation_interactor';

export default {
  name: 'signupFromInvitationInteractor',
  fn: SignupFromInvitationInteractor
};